import { createFileRoute } from '@tanstack/react-router';
import { FormPageTemplatePending } from '@/components/v2/page-template-pending';

export const Route = createFileRoute('/_authenticated/listings/')({
  // Template-first pending while the form chunk downloads (the zod/react-form
  // graph stays lazy, so the def file carries the shell). The destination IS a
  // form: arrow-back header, the page's real title/subtitle strings, and its
  // submit in the sticky BottomAction bar — a list template read as the wrong
  // destination.
  pendingComponent: () => (
    <FormPageTemplatePending
      title="Contribute to the Community"
      subtitle="Know a class, instructor, studio, or blog we're missing? Share it here."
      variant="arrow"
      cta
    />
  ),
});
